<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>角色列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图 -->
    <el-card>
      <!-- 添加角色按钮区域 -->
      <el-row v-if="canLook == 1">
        <el-col>
          <el-button type="primary" @click="addDialogVisible = true">添加角色</el-button>
        </el-col>
      </el-row>

      <!-- 角色列表区域 row-key="id" -->
      <el-table :data="rolelist" border stripe>
        <!-- 展开列 -->
        <!-- <el-table-column type="expand">
          <template slot-scope="scope">
            <el-row :class="['bdbottom', i1 === 0 ? 'bdtop' : '', 'vcenter']" v-for="(item1, i1) in scope.row.children" :key="item1.id">
             <el-col :span="5">
                <el-tag closable @close="removeRightById(scope.row, item1.id)">{{ item1.name }}</el-tag>
                <i class="el-icon-caret-right"></i>
              </el-col>
              <el-col :span="19">
                <el-row :class="[i2 === 0 ? '' : 'bdtop', 'vcenter']" v-for="(item2, i2) in item1.children" :key="item2.id">
                  <el-col :span="6">
                    <el-tag type="success" closable @close="removeRightById(scope.row, item2.id)">{{ item2.name }}</el-tag>
                    <i class="el-icon-caret-right"></i>
                  </el-col>
                  <el-col :span="18">
                    <el-tag type="warning" v-for="item3 in item2.children" :key="item3.id" closable @close="removeRightById(scope.row, item3.id)">{{ item3.authName }}</el-tag>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </template>
        </el-table-column> -->

        <!-- 索引列 -->
        <el-table-column type="index"></el-table-column>
        <el-table-column label="角色名称" prop="name" width="150px"></el-table-column>
        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="showEditDialog(scope.row.id)">编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="removeUserById(scope.row.id)">删除</el-button>
            <el-button size="mini" type="warning" icon="el-icon-setting" @click="showSetRightDialog(scope.row)">分配权限</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 分配权限的对话框 -->
    <el-dialog title="分配权限" :visible.sync="setRightDialogVisible" width="50%" @close="setRightDialogClosed">
      <!-- <el-tree :data="rightslist" 
      :props="treeProps" 
      show-checkbox 
      node-key="id"
       default-expand-all 
      :default-checked-keys="defKeys" 
      ref="treeRef"></el-tree> -->

      <el-tree :data="rightslist" :props="treeProps" show-checkbox node-key="id" default-expand-all :default-checked-keys="defKeys" ref="treeRef" :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, rightslist }">
          <span>{{ node.label }}</span>
          <span v-if="node.data.level > 0">
            <el-radio v-model="node.data.canLook" label="1" @change="() => operation(node, rightslist)">操作</el-radio>
            <el-radio v-model="node.data.canLook" label="2" @change="() => lookOnly(node, rightslist)">可查看</el-radio>
            <!-- <el-button type="text" size="mini" @click="() => append(rightslist)"> 查看 </el-button>
            <el-button type="text" size="mini" @click="() => remove(node, rightslist)"> 操作 </el-button> -->
          </span>
        </span>
      </el-tree>

      <span slot="footer" class="dialog-footer">
        <el-button @click="setRightDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="allotRights">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加用户的对话框 -->
    <el-dialog title="添加角色" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="130px">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改用户的对话框 -->
    <el-dialog title="修改角色" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="editForm" :rules="addFormRules" ref="editFormRef" label-width="130px">
        <el-form-item label="角色名称">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editUserInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      canLook: 1,
      // 所有角色列表数据
      rolelist: [],
      // 控制分配权限对话框的显示与隐藏
      setRightDialogVisible: false,
      // 所有权限的数据
      rightslist: [],
      // 树形控件的属性绑定对象
      treeProps: {
        label: 'name',
        children: 'children',
        check: 'check',
      },

      // 默认选中的节点Id值数组
      defKeys: [],
      // 当前即将分配权限的角色id
      roleId: '',
      // node: this.rightslist,
      addDialogVisible: false,
      // 添加用户的表单数据
      addForm: {
        name: '',
      },
      // 添加表单的验证规则对象
      addFormRules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
        ],
      },

      editDialogVisible: false,
      // 添加用户的表单数据
      editForm: {
        name: '',
      },
      // 添加表单的验证规则对象
      editFormRules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
        ],
      },
    }
  },

  created () {
    this.getRolesList()
  },

  methods: {
    //操作
    operation (node, data) {
      this.$refs.treeRef.setChecked(node, true);
    },

    //查看
    lookOnly (node, data) {
      console.log(node);
      this.$refs.treeRef.setChecked(node, true);
    },

    // 获取所有角色的列表
    async getRolesList () {
      const { data: res } = await this.$http.get('/admin/user/roles')
      if (res.code !== 200) {
        return this.$message.error('获取角色列表失败！')
      }
      this.rolelist = res.result
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
      console.log(this.rolelist)
    },

    // 根据Id删除对应的权限
    async removeRightById (role, rightId) {
      // 弹框提示用户是否要删除
      const confirmResult = await this.$confirm(
        '此操作将永久删除, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消了删除！')
      }
      const { data: res } = await this.$http.post(
        'admin/user/deleteRoleRightById',
        {
          role_id: role.id,
          right_id: rightId
        }
      )
      if (res.code !== 200) {
        return this.$message.error('删除权限失败！')
      }
      this.getRolesList()
      // role.children = res.data
    },

    // 展示分配权限的对话框
    async showSetRightDialog (role) {
      this.roleId = role.id
      // 获取所有权限的数据
      const { data: res } = await this.$http.get('/admin/user/roleTree', {
        params: {
          roleid: role.id
        }
      })
      if (res.code !== 200) {
        return this.$message.error('获取权限数据失败！')
      }
      // 把获取到的权限数据保存到 data 中
      this.rightslist = res.result.list
      this.defKeys = res.result.twoList
      console.log(this.rightslist)
      // 递归获取二级节点的Id
      // this.getLeafKeys(role, this.defKeys)
      // console.log(role)
      console.log(this.defKeys)
      this.setRightDialogVisible = true
    },

    // 通过递归的形式，获取角色下所有三级权限的id，并保存到 defKeys 数组中
    getLeafKeys (node, arr) {
      // 如果当前 node 节点不包含 children 属性，则是三级节点&& node.user != 1
      if (!node.children && node.user != 1) {
        return arr.push(node.id)
      }
      node.children.forEach(item => this.getLeafKeys(item, arr))
    },

    // 监听分配权限对话框的关闭事件
    setRightDialogClosed () {
      this.defKeys = []
    },

    // 点击为角色分配权限
    async allotRights () {
      const keys = [
        ...this.$refs.treeRef.getCheckedKeys(),
        ...this.$refs.treeRef.getHalfCheckedKeys()
      ]
      const nodes = [
        ...this.$refs.treeRef.getCheckedNodes(),
        ...this.$refs.treeRef.getHalfCheckedNodes()
      ]
      // const idStr = keys.join(',')
      var selectArr = [];
      nodes.forEach(ele => {
        if (ele.level > 0) {//第二级

          selectArr.push({ 'id': ele.id, 'name': ele.name, 'canLook': ele.canLook > 0 ? ele.canLook : '2' });
        } else {
          selectArr.push({ 'id': ele.id, 'name': ele.name });

        }
      })
      console.log(selectArr);
      // const idStr = selectArr.join(',')
      // return;
      const { data: res } = await this.$http.post(
        'admin/user/setRightsToRole',
        {
          role_ids: selectArr,// keys,
          role_id: this.roleId
        }
      )
      if (res.code !== 200) {
        return this.$message.error('分配权限失败！')
      }
      this.$message.success('分配权限成功！')
      this.getRolesList()
      this.setRightDialogVisible = false
    },
    // 监听添加用户对话框的关闭事件
    addDialogClosed () {
      this.$refs.addFormRef.resetFields()
    },

    // 点击按钮，添加新用户
    addUser () {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post('admin/user/addRole', this.addForm)
        if (res.code !== 200) {
          this.$message.error(res.message)
          return;
        }
        this.$message.success(res.message)
        // 隐藏添加用户的对话框
        this.addDialogVisible = false
        // 重新获取用户列表数据
        this.getRolesList()
      })
    },

    // 展示编辑用户的对话框
    async showEditDialog (id) {

      const { data: res } = await this.$http.get('admin/user/getRoleInfoById', {
        params: { id: id }
      })
      if (res.code !== 200) {
        return this.$message.error('查询用户信息失败！')
      }
      this.editForm = res.result
      this.editDialogVisible = true
    },

    // 监听修改用户对话框的关闭事件
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },
    // 修改用户信息并提交
    editUserInfo () {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        // 发起修改用户信息的数据请求
        const { data: res } = await this.$http.post(
          'admin/user/editRole',
          this.editForm
        )
        if (res.code !== 200) {
          return this.$message.error('操作失败！')
        }
        // 关闭对话框
        this.editDialogVisible = false
        // 刷新数据列表
        this.getRolesList()
        // 提示修改成功
        this.$message.success('更新角色信息成功！')
      })
    },
    // 根据Id删除对应的用户信息
    async removeUserById (id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将永久删除该角色, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post('admin/user/deleteRole', { id: id })
      if (res.code !== 200) {
        return this.$message.error('删除用户失败！')
      }
      this.$message.success('删除用户成功！')
      this.getRolesList()
    },

  }
}
</script>

<style lang="less" scoped>
.el-tag {
  margin: 7px;
}

.bdtop {
  border-top: 1px solid #eee;
}

.bdbottom {
  border-bottom: 1px solid #eee;
}

.vcenter {
  display: flex;
  align-items: center;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
